import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export async function getFavorites<T>(): Promise<Nullable<T>> {
    const url = CWEA_ENDPOINTS.favorites.get();

    return await cweaClient.get<T>(url, { useOldFetch: true });
}

export async function addFavorite<T>({ sku }: { sku: string }): Promise<Nullable<T>> {
    const url = CWEA_ENDPOINTS.favorites.post({ sku });

    return await cweaClient.post<T>(url, { useOldFetch: true });
}

export async function removeFavorite<T>({ sku }: { sku: string }): Promise<Nullable<T>> {
    const url = CWEA_ENDPOINTS.favorites.delete({ sku });

    return await cweaClient.delete<T>(url, { useOldFetch: true });
}
